<template>
    <div class="section_header">
        <router-link
            to="/"
            class="characteristics_title"
        >
            <img
                src="@/assets/logo_orange.png"
                class="logo_header"
            />
        </router-link>
        <p class="characteristics_title text_align_center title_header_one">
            {{ title }}
        </p>
        <a
            v-if="contactPhone"
            :href="contactHref"
            class="header_contact"
        >
            <span class="header_contact_label">{{ contactLabel }}</span>
            <span class="header_contact_phone">{{ contactPhone }}</span>
        </a>
        <ModalHeader />
    </div>
    <p class="characteristics_title text_align_center title_header_two">
        {{ title }}
    </p>
</template>

<script>
import ModalHeader from '@/shared/components/modal-header/ModalHeader.vue';
export default {
    components: { ModalHeader },
    props: {
        title: {
            type: String,
            default: '',
        },
        contactLabel: {
            type: String,
            default: '',
        },
        contactPhone: {
            type: String,
            default: '',
        },
        contactHref: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            showModal: false,
        };
    },
    methods: {
        toggleModal () {
            this.showModal = !this.showModal;
            this.toggleBurgerClasses();
            document.body.classList.toggle('no-scroll');
        },
        closeModal () {
            this.showModal = false;
            this.toggleBurgerClasses();
            document.body.classList.remove('no-scroll');
        },
        toggleBurgerClasses () {
            const burgerButton = document.querySelector('.burger_button');
            const burgerLines = document.querySelectorAll('.burger_line');

            if (this.showModal) {
                burgerButton.classList.add('active');
                burgerLines.forEach((line) => line.classList.add('active'));
            } else {
                burgerButton.classList.remove('active');
                burgerLines.forEach((line) => line.classList.remove('active'));
            }
        },
    },
};
</script>

<style scoped>
.logo_header{
    width: 3.55rem;
height: 2.55rem;
}

.header_contact {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
    color: rgb(25, 25, 25);
    transition: 0.2s ease;
}

.header_contact:hover {
    color: rgb(220, 102, 64);
}

.header_contact_label {
    font-family: Montserrat_Medium;
    font-size: 0.7rem;
    font-weight: 500;
    line-height: 0.85rem;
}

.header_contact_phone {
    font-family: Rostov;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1rem;
}

@media (max-width: 768px) {
    .header_contact {
        align-items: flex-start;
        position: absolute;
        right: 5.7rem;
        top: 2.25rem;
    }

    .header_contact_label {
        display: none;
    }

    .header_contact_phone {
        font-family: Montserrat_Medium;
        font-size: 0.75rem;
        line-height: 0.9rem;
    }
}
</style>
